import {Button} from '@/components/ui/button/Button'
import {Download01Icon} from '@/components/ui/icon/Icon'

export const DashboardExportButton = () => {
    const handleExport = () => {
        window.print()
    }

    return (
        <Button variant="secondary" onClick={handleExport} shape="square">
            <Download01Icon />
        </Button>
    )
}
